import { Fragment } from "react";

import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";

import { useLayout } from "@/providers";
import { ActivityLogs } from "./ActivityLogs";
import { useLocation } from "react-router-dom";
import { ExportLogs } from "./ExportLogs";
import { DeletedLogs } from "./DeletedLogs";

const AuditLogsManagement = () => {
  const { currentLayout } = useLayout();
  const location = useLocation();

  const renderLogsComponent = () => {
    if (location.pathname.endsWith("export-logs")) return <ExportLogs />;
    if (location.pathname.endsWith("delete-logs")) return <DeletedLogs />;
    return <ActivityLogs />;
  };

  return (
    <Fragment>
      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle id="audit-logs-management-heading" />
              <ToolbarDescription>
                You can manage your logs here.
              </ToolbarDescription>
            </ToolbarHeading>
          </Toolbar>
        </Container>
      )}
      <Container>{renderLogsComponent()}</Container>
    </Fragment>
  );
};

export { AuditLogsManagement };
